import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetBanners({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("BANNER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/banner", option);
    commit("BANNER_SUCCESS", _response);
  } catch (error) {
    commit("BANNER_ERROR", { result: error.message });
  }
}

export async function CreateBanner({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("CREATE_BANNER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/v1/banner", form);
    commit("CREATE_BANNER_SUCCESS", _response);
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_BANNER_ERROR", { result: error.message });
  }
}

export async function GetBanner({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("GET_BANNER_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get("/v1/banner/", id);
    commit("GET_BANNER_SUCCESS", _response.data);
  } catch (error) {
    commit("GET_BANNER_ERROR", { result: error.message });
  }
}

export async function UpdateBanner({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_BANNER_REQUEST");
    ApiService.setHeader();
    await ApiService.put("/v1/banner/" + form.id, form);
    commit("EDIT_BANNER_SUCCESS", form);
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_BANNER_ERROR", { result: error.message });
  }
}

export async function DeleteBanner({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("DELETE_BANNER_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/v1/banner/" + id);
    commit("DELETE_BANNER_SUCCESS", id);
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_BANNER_ERROR", { result: error.message });
  }
}
